
import * as React from 'react';
import * as rsuite from 'rsuite';
// import "bootstrap/dist/css/bootstrap.min.css";
// import 'bootstrap/dist/js/bootstrap';

import Layout from '../../Layout/CustomerLayout.js';
import * as General from '../General/General.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'
import PN from 'persian-number'

import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

// import GoogleMapReact from 'google-map-react';

const BuyFactorHistoryIndex = () => {

    //#region Const 
    const toaster = rsuite.useToaster();
    const [List, setList] = React.useState([]);
    const [background, Setbackground] = React.useState("");
    const [FactorNumber, SetFactorNumber] = React.useState("");
    const [Open, SetOpen] = React.useState("");
    const [ItemList, SetItemList] = React.useState([]);
    const [ShowFactorId, setShowFactorId] = React.useState(General.GuidEmpty());


    const ShowItem = (id, children, code) => {
        setShowFactorId(id);
        SetFactorNumber(code);
        SetOpen(true)

        var tmp = [];

        if (children != null) {
            for (var i = 0; i < children.length; i++) {
                // tax = tax + result.children[i].tax;
                tmp.push({
                    row: i + 1,
                    Product: children[i].product,
                    Count: children[i].count,
                    TotalPrice: children[i].totalPrice,
                    Price: children[i].price,
                    Tax: children[i].tax,
                    Unit: children[i].unit,
                    DiscountPrice: children[i].discountPrice,
                    DiscountPercent: children[i].discountPercent,

                })
            }

        }
        SetItemList(tmp)
    }

    const GetAllFactor = () => {

        var RequestOptions = {

            url: General.ApiRoute() + "/BuyOrder/Online_GetBySupplierId",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'SupplierId': localStorage.getItem("CustomerFarmAsanId"),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var tmp = []



                    for (var i = 0; i < result.data.length; i++) {
                        tmp.push({
                            Id: result.data[i].id,
                            Price: result.data[i].price,
                            DiscountPrice: result.data[i].discountPrice,
                            Code: result.data[i].code,
                            InsertDate: result.data[i].insertDate,
                            ItemCount: result.data[i].itemCount,
                            Children: result.data[i].children


                        })
                    }
                    setList(tmp)
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )

    }



    //#endregion
    React.useEffect(() => {
        GetAllFactor();
        document.title = "FarmAsan.ir ";
    }, [])


    return (
        <Layout title={'سابقه فروش کالا - ' + localStorage.getItem("UserFullNameFarmAsan")} >
            <rsuite.Row className="justify-content-center align-items-center pb-4 mb-4">
                <rsuite.Col xs={24} sm={24} md={24} lg={24} className="p-3">
                    <rsuite.Message type='success' className={List.length > 0 ? 'fw-bold' : "hide"}>
                        تعداد فاکتور : {List.length} عدد
                    </rsuite.Message>
                    <rsuite.Message type='warning' className={List.length == 0 ? 'fw-bold' : "hide"}>
                        فاکتور ثبت شده ای برای شما وجود ندارد
                    </rsuite.Message>
                </rsuite.Col>
                {List.map(factor => (
                    <rsuite.Col xs={24} sm={24} md={12} lg={12} className="p-3">
                        <rsuite.Panel className={ShowFactorId == factor.Id ? 'FarmAsan-success Font12 Cursor p-2' : 'FarmAsan-bg Font12 Cursor p-2'} onClick={() => ShowItem(factor.Id, factor.Children, factor.Code)} bodyFill>
                            <rsuite.Row >
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='p-1 p-2'>
                                    <b>شماره فاکتور: </b>{factor.Code}
                                </rsuite.Col >
                                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-1 p-2'>
                                    <b> تاریخ: </b> {factor.InsertDate}
                                </rsuite.Col>
                                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-1 p-2'>
                                    <b> تعداد اقلام : </b> {factor.ItemCount}
                                </rsuite.Col>
                                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-1 p-2'>
                                    <b> مبلغ: </b> {PN.sliceNumber(factor.Price)} <small> ریال</small>
                                </rsuite.Col>
                                <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-1 p-2'>
                                    <b>  تخفیف : </b> {PN.sliceNumber(factor.DiscountPrice)} <small> ریال</small>
                                </rsuite.Col>


                            </rsuite.Row>
                            <rsuite.Row >

                                <rsuite.Col xs={24} className="p-2">
                                    <rsuite.Button color="red" onClick={() => ShowItem()} className="border border-2 Font17" size="lg" style={{ color: "#ffff" }} block appearance="subtle">
                                        مشاهده جزییات فاکتور
                                    </rsuite.Button>
                                </rsuite.Col>
                            </rsuite.Row>

                        </rsuite.Panel>
                    </rsuite.Col>

                ))}
            </rsuite.Row>

            <rsuite.Drawer size={isMobile ? "full" : "md"}  placement="left" open={Open} onClose={() => (SetOpen(false), setShowFactorId(General.GuidEmpty()))}>
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title className=" Font13">
                        شماره فاکتور : {FactorNumber}
                    </rsuite.Drawer.Title>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body style={{ "background-color": "#2f4858",  "padding": "30px 30px" }} className="White_Text text-center">
                    {ItemList.map(item => (
                        <rsuite.Col xs={24} className=" border rounded-2 border-2 mb-2">
                            <rsuite.Panel bodyFill>
                                <rsuite.Row className='mt-2'>
                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                        <b>محصول : </b>{item.Product}
                                    </rsuite.Col >
                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                        <b> تعداد: </b> {item.Count}  {item.Unit}
                                    </rsuite.Col>
                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                        <b>  قیمت واحد : </b> {PN.sliceNumber(item.Price)} ریال
                                    </rsuite.Col>
                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                        <b>  مالیات  : </b> {PN.sliceNumber(item.Tax)} ریال
                                    </rsuite.Col>
                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                        <b>  تخفیف  : </b> {PN.sliceNumber(item.DiscountPrice)} ریال
                                    </rsuite.Col>
                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                        <b>  قیمت کل : </b> {PN.sliceNumber(item.TotalPrice)} ریال
                                    </rsuite.Col>
                                </rsuite.Row>
                            </rsuite.Panel>
                        </rsuite.Col>
                    ))}
                </rsuite.Drawer.Body>
            </rsuite.Drawer >
        </Layout >
    )
}

export default BuyFactorHistoryIndex;





